function initAccordions(containerSelector, options = {}) {
  const { singleOpen = true } = options;
  document.querySelectorAll(containerSelector).forEach(container => {
    const items = Array.from(container.querySelectorAll('li'));
    // zabezpieczenie: jeśli nie ma elementów, pomiń
    if (!items.length) return;

    // kliknięcie na element
    const onClick = (item) => {
      if (singleOpen) {
        items.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
      } else {
        item.classList.toggle('active');
      }
    };

    // dodaj nasłuchiwacze
    items.forEach(item => {
      item.addEventListener('click', () => onClick(item));
    });
  });
}

initAccordions('.panels__panels');
